import { Box, IconButton, useTheme, useMediaQuery } from "@mui/material";
import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Importar hook para navegación y ubicación
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import ReportIcon from "@mui/icons-material/Report";
import SearchIcon from "@mui/icons-material/Search";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const location = useLocation(); // Obtener la ubicación actual
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      px={isMobile ? 2 : 3}
      py={1}
      sx={{
        backgroundColor: colors.primary[400],
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        minHeight: "64px",
      }}
    >
      {/* Sección Izquierda: Logo */}
      <Box display="flex" alignItems="center">
        <Box sx={{ width: isMobile ? "120px" : "210px", height: "auto" }}>
          <img
            src={
              theme.palette.mode === "dark"
                ? "/LogoBlanco.png"
                : "/Logo2026.png"
            }
            alt="Logo"
            style={{
              width: isMobile ? "100%" : "200%",
              height: "auto",
              display: "block",
            }}
          />
        </Box>
      </Box>

      {/* Botones de navegación (Centro en escritorio) */}
      {location.pathname !== "/consultaUsuario" && (
        <Box
          display="flex"
          alignItems="center"
          sx={{
            flex: isMobile ? "0 1 auto" : "1",
            justifyContent: isMobile ? "flex-end" : "center",
            height: isMobile ? "auto" : "64px",
          }}
        >
          {isMobile ? (
            <Box display="flex" gap={0.5}>
              <IconButton
                onClick={() => navigate("/protecUsuario")}
                sx={{
                  backgroundColor:
                    location.pathname === "/protecUsuario"
                      ? colors.blueAccent[400]
                      : "transparent",
                  color: colors.grey[100],
                  borderRadius: "8px",
                  padding: "8px",
                }}
              >
                <ReportIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={() => navigate("/buscarSolicitud")}
                sx={{
                  backgroundColor:
                    location.pathname === "/buscarSolicitud"
                      ? colors.blueAccent[400]
                      : "transparent",
                  color: colors.grey[100],
                  borderRadius: "8px",
                  padding: "8px",
                }}
              >
                <SearchIcon fontSize="small" />
              </IconButton>
            </Box>
          ) : (
            <Box display="flex" height="100%" alignItems="center">
              {/* Opción: Hacer denuncia */}
              <Box
                onClick={() => navigate("/protecUsuario")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  px: 4,
                  height: "100%",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  backgroundColor:
                    location.pathname === "/protecUsuario"
                      ? "rgba(255, 255, 255, 0.05)"
                      : "transparent",
                  borderBottom:
                    location.pathname === "/protecUsuario"
                      ? `4px solid ${colors.blueAccent[500]}`
                      : "4px solid transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                  },
                }}
              >
                <ReportIcon
                  sx={{
                    color:
                      location.pathname === "/protecUsuario"
                        ? colors.blueAccent[400]
                        : colors.grey[100],
                    fontSize: "22px",
                  }}
                />
                <Box
                  component="span"
                  sx={{
                    color: colors.grey[100],
                    fontWeight: "600",
                    fontSize: "0.9rem",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                  }}
                >
                  Hacer denuncia
                </Box>
              </Box>

              {/* Separador */}
              <Box
                sx={{
                  width: "1px",
                  height: "24px",
                  backgroundColor: colors.grey[700],
                  opacity: 0.5,
                  mx: 0.5,
                }}
              />

              {/* Opción: Ver denuncia */}
              <Box
                onClick={() => navigate("/buscarSolicitud")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  px: 4,
                  height: "100%",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  backgroundColor:
                    location.pathname === "/buscarSolicitud"
                      ? "rgba(255, 255, 255, 0.05)"
                      : "transparent",
                  borderBottom:
                    location.pathname === "/buscarSolicitud"
                      ? `4px solid ${colors.blueAccent[500]}`
                      : "4px solid transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                  },
                }}
              >
                <SearchIcon
                  sx={{
                    color:
                      location.pathname === "/buscarSolicitud"
                        ? colors.blueAccent[400]
                        : colors.grey[100],
                    fontSize: "22px",
                  }}
                />
                <Box
                  component="span"
                  sx={{
                    color: colors.grey[100],
                    fontWeight: "600",
                    fontSize: "0.9rem",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                  }}
                >
                  Ver denuncia
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      )}

      {/* Sección Derecha: Modo oscuro/claro */}
      <Box
        display="flex"
        alignItems="center"
        sx={{
          width: isMobile ? "auto" : "180px",
          justifyContent: "flex-end",
        }}
      >
        <IconButton
          onClick={colorMode.toggleColorMode}
          sx={{
            transition: "all 0.3s ease",
            "&:hover": { transform: "scale(1.1)" },
          }}
        >
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;
